<template>
  <div v-show="isActive">
    <slot v-if="!lazy || wasActive"></slot>
  </div>
</template>

<script>
  export default {
    name: 'STab',
    props: {
      name: {
        type: String,
        required: true,
      },
      selected: {
        type: Boolean,
        default: false,
      },
      // Рендерить содержимое только после первого открытия вкладки
      lazy: {
        type: Boolean,
        default: false,
      },
    },

    data () {
      return {
        isActive: false,
        wasActive: false,
      }
    },

    watch: {
      isActive (val) {
        if (val) this.wasActive = true
      },
      selected: {
        handler (val) {
          this.isActive = val
        },
        deep: true,
      },
    },
    computed: {
      href () {
        return '#' + this.name.toLowerCase().replace(/ /g, '-')
      },
    },
    created () {
      this.isActive = this.selected
      this.wasActive = this.selected
    },
  }
</script>

<style scoped>

</style>
